import { BUSINESS } from "@/lib/config";

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export default function Nav() {
  return (
    <header
      className="sticky top-0 z-50 border-b border-zinc-800 bg-zinc-950/90 backdrop-blur-md"
      data-testid="site-nav"
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6">
        <button
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center gap-3 text-left"
          data-testid="nav-brand"
        >
          <img
            src={BUSINESS.logoSrc}
            alt={`${BUSINESS.name} logo`}
            className="h-11 w-11 border border-zinc-800 bg-white object-contain p-0.5"
          />
          <span className="font-display text-xl tracking-tight text-white">
            {BUSINESS.shortName}
          </span>
        </button>

        <nav className="hidden items-center gap-8 md:flex">
          <button
            onClick={() => scrollToId("services")}
            className="font-mono-spec text-zinc-400 transition-colors duration-100 hover:text-white"
            data-testid="nav-services"
          >
            Services
          </button>
          <button
            onClick={() => scrollToId("materials")}
            className="font-mono-spec text-zinc-400 transition-colors duration-100 hover:text-white"
            data-testid="nav-materials"
          >
            Materials
          </button>
          <button
            onClick={() => scrollToId("process")}
            className="font-mono-spec text-zinc-400 transition-colors duration-100 hover:text-white"
            data-testid="nav-process"
          >
            Process
          </button>
          <button
            onClick={() => scrollToId("faq")}
            className="font-mono-spec text-zinc-400 transition-colors duration-100 hover:text-white"
            data-testid="nav-faq"
          >
            FAQ
          </button>
        </nav>

        <button
          onClick={() => scrollToId("book")}
          className="h-10 border-2 border-orange-600 bg-orange-600 px-5 font-display text-sm uppercase tracking-wider text-white transition-colors duration-100 hover:bg-orange-700"
          data-testid="nav-book-call-btn"
        >
          Book a Call
        </button>
      </div>
    </header>
  );
}
